import {Plugins} from '@packages/systems/wfdl';
import * as wast from '@packages/systems/wfdl-ast';
import {qualify, typeName} from '@packages/systems/wfdl-Qualified';
import {
  PhoneType,
  NonEmptyPhoneType,
  OptionalPhoneType,
} from './PhoneAliasType';

import PhoneIcon from './icons/Phone';

export const TPhone = wast.TTypeConstructor(
  qualify(Plugins.name('Phone'), typeName('Phone'))
);

export const TNonEmptyPhone = wast.TTypeConstructor(
  qualify(Plugins.name('Phone'), typeName('Non-empty Phone'))
);

export const TOptionalPhone = wast.TTypeConstructor(
  qualify(Plugins.name('Phone'), typeName('Optional Phone'))
);

export const plugin = Plugins.PrivilegedPlugin({
  dataTypes: {
    Phone: PhoneType,
    'Non-empty Phone': NonEmptyPhoneType,
    'Optional Phone': OptionalPhoneType,
  },

  icons: {
    Phone: PhoneIcon,
  },
});
